import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'trello',
  version: '1.4.0',
  properties: [
    // Properties will be defined based on n8n equivalents
  ]
};

export default schema;
